import { OpenAPI } from 'api-clients/monolith';
import { useLocation, useParams } from 'react-router-dom';
import { RouteParams } from 'types';

export const useJobApplication = () => {
  const { accountSlug, brandId } = useParams<RouteParams>();
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const handleApplyClick = (id: string) => {
    const url = new URL(`${OpenAPI.BASE}/${accountSlug}/apply/${id}`);
    url.searchParams.set('utm_medium', 'ai-career-site');

    ['source', 'campaign', 'medium', 'term', 'content'].forEach(param => {
      const value = params.get(`utm_${param}`);
      if (value) url.searchParams.set(`utm_${param}`, value);
    });

    ['short_code_applicant_id', 'keyword_id'].forEach(param => {
      const value = params.get(param);
      if (value) url.searchParams.set(param, value);
    });

    const referralWorkerName = params.get('referralWorkerName');
    if (referralWorkerName) {
      url.searchParams.set('referralWorkerName', referralWorkerName);
    }

    const localeParam = params.get('locale');
    if (localeParam) {
      url.searchParams.set('locale', localeParam);
    }

    url.searchParams.set('brand_id', brandId ?? 'all');

    window.open(url, '_blank');
  };

  return { handleApplyClick };
};
